import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import TextBox from "../Input/TextBox";
import { onContact } from "../../src/utils/queries";
import CircleSpinner from "../Spinner/Index";
import toast from "react-hot-toast";
import { useAuthProvider } from "../../context/AuthProvider";
const ContactModal = ({isBlue}) => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const { mutate, isSuccess, isError, isLoading, data } = onContact();

  const handleClickOpen = () => {
    setShow(true);
  };

  const handleClose = () => {
    setMessage('')
    setMessageType('')
    setShow(false);

  };

  const handleChange = (e) => {
    setMessageType(e.target.value);
  };


  const {first_name, last_name, email, user} = useAuthProvider()

  useEffect(() => {
    if (isSuccess) {
      handleClose()
      setTimeout(()=>{
        toast.success(
          "Thank you for contacting support, your message has been recorded and will be attended to within 48 hours"
        );
      }, 500)

    }

    if (isError) {
      handleClose()
      setTimeout(()=>{
        toast.error(
          "Sorry your request could not be processed at this time, please try again or send a message to info@idonatio.com"
        );
      }, 500)
  
    }
  }, [isSuccess, isError]);

  return (
    <div>
      <Typography
        variant={isBlue ? 'small':"big"}
        component={"p"}
        marginTop="1em"
        onClick={handleClickOpen}
        sx={{ cursor: "pointer", color:isBlue?'#2962ff':null }}
      >
        Contact us
      </Typography>

      <Dialog
        open={show}
        fullWidth
        maxWidth={"sm"}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          // minHeight:'10rem',
          zIndex: "10005",
          "& .MuiDialog-paper": {
            px: "1.2em",
            py: "1em",
            borderRadius: "8px",
            minHeight: "27rem",
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontSize: "18px",
            fontWeight: 500,
            color: "grey.dark",
            marginBottom: "1em",
            justifyContent: "space-between",
            display: "flex",
            "& svg": {
              padding: "0",
            },
          }}
        >
          <Typography
            variant="h4"
            component={"h4"}
            fontWeight={500}
            lineHeight={"24px"}
            display="flex"
            justifyContent={"center"}
            alignItems={"center"}
          >
            Send a message
          </Typography>

          <IconButton
            aria-label="close"
            size="large"
            sx={{ fontSize: "1.4rem" }}
            onClick={handleClose}
          >
            <ClearRoundedIcon fontSize="inherit" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div>
            <Typography variant="big" fontWeight={500} component={"p"}>
              Enquiry type
            </Typography>
            <FormControl sx={{ width: "100%" }}>
              <Select
                fullWidth
                displayEmpty
                size="small"
                // disabled={email == userEmail}
                value={messageType}
                placeholder="selected"
                onChange={handleChange}
                sx={{
                  width: "100%",
                  // borderRadius: "16px",
                  "&.Mui-focused": {
                    // color:"primary.main",
                    // border:"1px solid black",
                    "& .MuiOutlinedInput-notchedOutline": {
                      boxShadow: "none",
                      //used to remove blue styling
                      border: "1px solid",
                      borderColor: "grey.main",
                    },
                  },
                }}
              >
                <MenuItem value={"Help & support"}>Help & support</MenuItem>
                <MenuItem value={"General enquiry"}>General enquiry</MenuItem>
                <MenuItem value={"Sales"}>Sales</MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
              </Select>
            </FormControl>
            <Typography
              variant="big"
              fontWeight={500}
              component={"p"}
              marginTop="2em"
            >
              Message
            </Typography>

            <TextBox
              setText={setMessage}
              text={message}
              max={500}
              disabled={false}
            />
            <Typography variant="small">
              *Please make your message as descriptive as possible to ensure the
              swift resolution of your complaint/enquiry
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mt: "2em" }}
            >
              <Button
                disabled={!message || isLoading || !messageType}
                onClick={() => {
                  mutate({email,
                    enquiry_type:messageType,
                    first_name,
                    is_subscribed:true,
                    last_name,
                    message,
                    phone_number: user?.phone_number});
                }}
                sx={{
                  borderRadius: "8px",
                  paddingY: "8px",
                  paddingX: "12px",
                  fontSize: "14px",
                  fontWeight: "600",
                  textTransform: "none",
                  "&.Mui-disabled": {
                    opacity: "0.3",
                    backgroundColor: "primary.main",
                    color: "white",
                  },
                }}
                variant="contained"
                color="primary"
                disableElevation
                disableFocusRipple
                disableRipple
              >
                {isLoading ? <CircleSpinner /> : "Send"}
              </Button>
              <Button
                onClick={handleClose}
                sx={{
                  borderRadius: "8px",
                  paddingY: "8px",
                  paddingX: "12px",
                  fontSize: "14px",
                  fontWeight: "600",
                  textTransform: "none",
                  "&.Mui-disabled": {
                    opacity: "0.3",
                    // backgroundColor: "primary.main",
                    color: "white",
                  },
                }}
                color="primary"
                disableElevation
                disableFocusRipple
                disableRipple
              >
                Cancel
              </Button>
            </Box>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ContactModal;
